export const BUCKET_NAME = 'dcui-assets';